import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';

// registerServiceWorker();
unregister(); // For now until the service worker could be useful
ReactDOM.render(<App />, document.getElementById('root'));
